import { HIDDEN_FILTER_APP_PART_TYPES as APP_HIDDEN_FILTER_APP_PART_TYPES } from "@lhd/features/Apps/constants";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import { CONTRACT_STATUS } from "@lhd/types";
export const APP_TYPES = {
  REGISTRATION_INFORMATION: "registration_information",
  EMPLOYMENT_CONTRACTS: "employment_contracts",
  AGREEMENTS: "agreements",
  COMPANY_POLICIES: "company_policies",
  ROLE_PERMISSIONS: "role_permissions",
  BUSINESS_TRIP_REPORTS: "business_trip_reports",
  LABOR_DOCUMENTS: "labor_documents",
  FINANCIAL_REPORTS: "financial_reports",
  BUSINESS_MANUALS: "business_manuals",
  BUSINESS_FLOW: "business_flowcharts",
} as const;

export type StatusContactType = CONTRACT_STATUS;

export const STATUS_CONTACT_LABEL_MAP = {
  DRAFTING: "作成中",
  PENDING_SIGNATURE: "契約待ち",
  ACTIVE: "適用中",
  ARCHIVED: "過去ログ",
};

export const STATUS_CONTACT_OPTIONS = [
  {
    value: CONTRACT_STATUS.DRAFTING,
    label: STATUS_CONTACT_LABEL_MAP.DRAFTING,
  },
  {
    value: CONTRACT_STATUS.PENDING_SIGNATURE,
    label: STATUS_CONTACT_LABEL_MAP.PENDING_SIGNATURE,
  },
  {
    value: CONTRACT_STATUS.ACTIVE,
    label: STATUS_CONTACT_LABEL_MAP.ACTIVE,
  },
  {
    value: CONTRACT_STATUS.ARCHIVED,
    label: STATUS_CONTACT_LABEL_MAP.ARCHIVED,
  },
];
/// done for app_part_type= status_contact

export const MULTIPLE_SELECTS = [
  APP_PART_TYPES.MULTI_CHOICE,
  APP_PART_TYPES.WORKER_SELECTION,
  APP_PART_TYPES.DEPARTMENT_SELECTION,
  APP_PART_TYPES.DIVISION_SELECTION,
  APP_PART_TYPES.ORGANIZATION_SELECTION,
  APP_PART_TYPES.REPRESENTATIVE_SELECTION,
  APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION,
  APP_PART_TYPES.POSITION_SELECTION,
  APP_PART_TYPES.CUSTOMER_SELECTION,
];

export const SELECTIONS_APP_PARTS: string[] = [
  APP_PART_TYPES.WORKER_SELECTION,
  APP_PART_TYPES.DEPARTMENT_SELECTION,
  APP_PART_TYPES.DIVISION_SELECTION,
  APP_PART_TYPES.ORGANIZATION_SELECTION,
  APP_PART_TYPES.COMPANY_LOCATION_SELECTION,
  APP_PART_TYPES.REPRESENTATIVE_SELECTION,
  APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION,
  APP_PART_TYPES.POSITION_SELECTION,
  APP_PART_TYPES.CUSTOMER_SELECTION,
];

export enum ROLE_SIGNATURE {
  EMPLOYER = "employer",
  EMPLOYEE = "employee",
}

export const BACK_NAVIGATE_URL_KEY = "backNavigateUrl";

export const SEPARATE = ",";

export const HIDDEN_FILTER_APP_PART_TYPES = [
  ...APP_HIDDEN_FILTER_APP_PART_TYPES,
  APP_PART_TYPES.LABEL,
  APP_PART_TYPES.VERTICAL_BORDER,
  APP_PART_TYPES.HORIZONTAL_BORDER,
  APP_PART_TYPES.RICH_TEXT,
];

export const NUMBER_ADD_MORE_RECORD_SHEET = 10;

//company_policies
//カテゴリー
export const COMPANY_POLICIES_EXTEND_OPTIONS = [
  {
    name: "規程種別",
    options: [
      {
        label: "取締役会規程",
        value: "取締役会規程",
      },
      {
        label: "監査役会規程",
        value: "監査役会規程",
      },
      {
        label: "組織規定",
        value: "組織規定",
      },
      {
        label: "稟議規定",
        value: "稟議規定",
      },
      {
        label: "職務権限規程",
        value: "職務権限規程",
      },
      {
        label: "関係会社管理規定",
        value: "関係会社管理規定",
      },
      {
        label: "会議体規程",
        value: "会議体規程",
      },
      {
        label: "コンプライアンス規定",
        value: "コンプライアンス規定",
      },
      {
        label: "リスクマネジメント規程",
        value: "リスクマネジメント規程",
      },
      {
        label: "反社会的勢力対策規程",
        value: "反社会的勢力対策規程",
      },
      {
        label: "車両管理規程",
        value: "車両管理規程",
      },
      {
        label: "株式取扱規程",
        value: "株式取扱規程",
      },
      {
        label: "経理規定",
        value: "経理規定",
      },
      {
        label: "予算管理規程",
        value: "予算管理規程",
      },
      {
        label: "原価計算規程",
        value: "原価計算規程",
      },
      {
        label: "電子化保存規定",
        value: "電子化保存規定",
      },
      {
        label: "固定資産管理規程",
        value: "固定資産管理規程",
      },
      {
        label: "従業員持株会規約",
        value: "従業員持株会規約",
      },
      {
        label: "ハラスメント防止規程",
        value: "ハラスメント防止規程",
      },
      {
        label: "個人情報取扱規程",
        value: "個人情報取扱規程",
      },
      {
        label: "情報セキュリティ規程",
        value: "情報セキュリティ規程",
      },
      {
        label: "内部通報規程",
        value: "内部通報規程",
      },
      {
        label: "与信管理規程",
        value: "与信管理規程",
      },
      {
        label: "賃金規定",
        value: "賃金規定",
      },
      {
        label: "賞与規程",
        value: "賞与規程",
      },
      {
        label: "退職金規程",
        value: "退職金規程",
      },
      {
        label: "慶弔見舞金規程",
        value: "慶弔見舞金規程",
      },
      {
        label: "国内出張旅費規程",
        value: "国内出張旅費規程",
      },
      {
        label: "育児・介護休業等に関する規程",
        value: "育児・介護休業等に関する規程",
      },
      {
        label: "在宅勤務規程",
        value: "在宅勤務規程",
      },
      {
        label: "人事考課規程",
        value: "人事考課規程",
      },
      {
        label: "外注管理規程",
        value: "外注管理規程",
      },
      {
        label: "販売管理規程",
        value: "販売管理規程",
      },
    ],
  },
];

// Currency symbols used to detect money fields in business trip reports
export const CURRENCY_UNITS = ["¥", "￥", "円"];

/** Min height of the title block that sits above every titled field. */
export const TITLE_MIN_HEIGHT = 22;

/** Height the form controls are stretched to inside LayoutApp. */
export const FIELD_CONTROL_HEIGHT = 40;

/** App part types that render no title above their field. */
export const HIDDEN_TITLE_APP_PART_TYPES = [
  APP_PART_TYPES.LABEL,
  APP_PART_TYPES.VERTICAL_BORDER,
  APP_PART_TYPES.HORIZONTAL_BORDER,
  APP_PART_TYPES.SIGNATURE,
  APP_PART_TYPES.TABLE,
];

/**
 * Labels whose whole content is one of these is an operator placed between
 * fields, not text of its own. Only those get lined up with the controls
 * beside them; every other label is left exactly as authored.
 */
export const OPERATOR_LABEL_TEXTS = ["＋", "+", "▲"];
